import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { Icon } from "@iconify/react";
import Messages from "../MessageCenter/Messages";
import MobileDataComparison from "./MobileDataComparison";
import MobileSidebar from "../../components/Sidebar/MobileSidebar";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import BottomNav from "../../components/BottomNav/BottomNav";


class MobileDashboard extends Component {
    constructor(props) {
      super(props);
      this.state = {
        activeSieBar: false,
        showData: false,
      }
    };

    toggleSideBar = () => {
        this.setState({
          activeSieBar: !this.state.activeSieBar,
        });
      };

    toggleShowData = () => {
        this.setState({
            showData: !this.state.showData,
        });
    };

    imageImport = (r) => {
        let images = {};
        r.keys().map((item) => {
          return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
      };

    render() {
        const { t } = this.props;
        const icon = this.imageImport(require.context("../../assets/images/dashboard", false, /\.(png|jpe?g|svg|webp)$/));
        const slateGray = "#8b9ccb";
        let lastMonthLabel = t('dashboard.last-month');
        let thisMonthLabel = t('dashboard.this-month');
        if(this.state.chartTab === 0){
          lastMonthLabel += ' (USD)';
          thisMonthLabel += ' (USD)';
        }

        return (
            <Auxiliary>
                {this.state.showData &&
                <MobileDataComparison 
                        {...this.state}
                        {...this.props}
                        toggleShowData={this.toggleShowData}
                        handleGraph = {this.props.handleGraph}
                />
                }
                <section className="pf-m-dashboard">
                    {/* <div className="side-bar-mobile">
                        <div className="m-subHeader bg-white" style={{ justifyContent: "flex-start" }}>
                            <div className="sb-toggle-btn w-25" onClick={this.toggleSideBar}>
                                <Icon icon="ph:squares-four-fill" />
                                {(() => {
                                    if (!this.state.msgLoading) {
                                    if (this.state.unreadMsgCnt > 0) {
                                        return <span className="notify-red-dot" />;
                                    }
                                    }
                                })()}
                            </div>
                            <h6>{t('sidebar.dashboard')}</h6>
                        </div>
                    </div> */}
                    <MobileSidebar />
                    <div className="db-col col-12 p-3">
                        <div className="row g-2">
                                { this.props.widgetsArr && this.props.widgetsArr.map((item, index) => (
                                    <div className="col-4" key={index}>
                                    <div className="db-tp-panels">
                                    <img src={icon[`${item.img}`]} alt={item.label} />
                                    <h4>{item.value}</h4>
                                    <p>{item.label}</p>
                                    </div>
                                </div>
                                ))}
                            </div> 
                    </div>
                        <form className="forms-col needs-validation mb-3" method="post" noValidate>
                        <div className="pd-form-m-col">
                            <div className="input-group-col">
                                <div className="input-group right align-items-center">
                                    <img src={icon["data-compare.svg"]} alt="data icon" className="mx-1 "/> 
                                    <p className="form-control lh-lg "> {t("dashboard.data-compare")}</p>
                                        <span className="input-group-text" onClick={this.toggleShowData} >
                                            <Icon icon="uil:angle-right" />
                                        </span>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
                <BottomNav />

            </Auxiliary>
            );
        }
      }


export default (withNamespaces('translation')(MobileDashboard));